import axios from "axios";
import dayjs from "dayjs";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { API } from "../../helpers/constants";
import { handleAxiosErrors } from "../../helpers/errorHandling";
import { NAVIGATION } from "../../locales/components/namespaces";
import useUserData from "./useUserData";

const useKpis = () => {
	const {token, dateFormat} = useUserData()
	const { t } = useTranslation(NAVIGATION)
	const [loading, setLoading] = useState(false)
	const [data, setData] = useState({
		projects: 0,
		foremen: 0,
		workers: 0,
		lastLogin: null,
		insertDate: null
	})
	
	useEffect(() => {
		setLoading(true)
		axios({
			method: 'post',
			headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
			url: `${API}/en/fts/kpi`
		}).then(res => {
			const data = res.data
			setData({
				projects: data.projects,
				foremen: data.foremen,
				workers: data.workers,
				lastLogin: data.lastLogin ? dayjs(data.lastLogin).format(dateFormat) : '-',
				insertDate: data.insert ? dayjs(data.insert).format(dateFormat) : '-'
			})
			setLoading(false)
		}).catch(error => {
			enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
				variant: 'warning',
				autoHideDuration: 3000,
			})
			setLoading(false)
		})
	}, [])
	
	return {
		loading,
		data
	}
}

export default useKpis